module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHomePage),
      expression: "isHomePage"
    }],
    staticClass: "tlt"
  }, [_c('span', [_vm._v("T")]), _c('span', [_vm._v("e")]), _c('span', [_vm._v("x")]), _c('span', [_vm._v("t")]), _vm._v(" "), _c('span', [_vm._v("I")]), _c('span', [_vm._v("n")]), _c('span', [_vm._v("v")]), _c('span', [_vm._v("e")]), _c('span', [_vm._v("r")]), _c('span', [_vm._v("s")]), _c('span', [_vm._v("e")])]), _vm._v(" "), _c('router-view'), _vm._v(" "), (!_vm.isHomePage) ? _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "menu ripple"
  }, [_c('i', {
    staticClass: "material-icons middle"
  }, [_vm._v("subdirectory_arrow_left")]), _vm._v(" "), _c('span', {
    staticClass: "middle"
  }, [_vm._v("Back")])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a1ff92f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 36
// module chunks = 0